module.exports = __webpack_public_path__ + "img/news-gallery-02.png?e30098a620a38e9e90f64bbd11cab3fb";